"use client";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import ParticlesComponent from "./ParticlesComponent";
import Navbar from "../../UI/Navbar";

const IntroSection = () => {
  return (
    <>
      <Box
        sx={{
          position: "relative",
          height: "67vh",
          backgroundColor: "black",
        }}
      >
        {/* Particles Background */}
        <ParticlesComponent id="particles" />
        {/* Navbar on top of particles and black background */}
        <Box sx={{ position: "relative", zIndex: 2 }}>
          <Navbar />
        </Box>
        {/* Main Heading Section */}
        <Box
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          sx={{
            padding: { xs: "20px 20px 0", md: "120px 103px" },
            maxWidth: { xs: "100%", md: "60%" },
            position: { xs: "static", md: "relative" },
            zIndex: 1,
            marginBottom: { xs: "100px", md: 0 },
            marginTop: { xs: "80px", md: "150px" },
          }}
        >
          <Typography
            component={motion.h1}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            variant="h1"
            sx={{
              fontSize: { xs: "32px", md: "84px" },
              lineHeight: { xs: 1.2, md: 1.2 },
              color: "#ffffff",
              fontWeight: 400,
              margin: 0,
              textAlign: { xs: "center", md: "left" },
              fontFamily: "Arial, sans-serif",
            }}
          >
            Make the world
          </Typography>
          <Typography
            component={motion.h1}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            variant="h1"
            sx={{
              fontSize: { xs: "32px", md: "84px" },
              lineHeight: { xs: 1.2, md: 1.2 },
              color: "#ffffff",
              fontWeight: 400,
              margin: 0,
              textAlign: { xs: "center", md: "left" },
              marginTop: { xs: "8px", md: 0 },
              fontFamily: "Arial, sans-serif",
            }}
          >
            a better place
          </Typography>
          <Typography
            component={motion.h1}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            variant="h1"
            sx={{
              fontSize: { xs: "32px", md: "84px" },
              lineHeight: { xs: 1.2, md: 1.2 },
              color: "#ffffff",
              fontWeight: 400,
              margin: 0,
              textAlign: { xs: "center", md: "left" },
              marginTop: { xs: "8px", md: 0 },
              fontFamily: "Arial, sans-serif",
            }}
          >
            with
            <motion.span
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              style={{ fontWeight: 700 }}
            >
              {" "}
              software
            </motion.span>
          </Typography>
        </Box>

        {/* Sub Heading Section */}
        <Box
          sx={{
            position: { xs: "relative", md: "absolute" },
            right: { xs: "auto", md: "103px" },
            top: { xs: "auto", md: "160px" },
            maxWidth: { xs: "100%", md: "40%" },
            zIndex: 1,
            paddingTop: { xs: "0", md: "0px" },
            margin: { xs: "-50px auto", md: "0" },
            paddingX: { xs: "20px", md: "0" },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "16px", md: "20px" },
              lineHeight: 1.5,
              color: "#ffffff",
              fontWeight: 400,
              marginBottom: { xs: "20px", md: "28px" },
              lineHeight: "24.2px",
              textAlign: { xs: "center", md: "left" },
              fontFamily: "Arial, sans-serif",
            }}
          >
            We are passionate about creating innovative solutions that transform
            businesses and enhance user experiences through cutting-edge
            technology and thoughtful design.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              width: "100%",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.3,
                type: "spring",
                stiffness: 100,
              }}
              whileHover={{
                scale: 1.05,
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.95 }}
            >
              <Button
                variant="outlined"
                sx={{
                  color: "#ffffff",
                  borderColor: "#ffffff",
                  backgroundColor: "transparent",
                  borderRadius: "50px",
                  padding: "15px 15px",
                  fontWeight: 700,
                  marginTop: { xs: "8px", md: "12px" },
                  width: { xs: "200px", md: "auto" },
                  fontFamily: "Arial, sans-serif",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderColor: "#ffffff",
                  },
                }}
              >
                Let's Started
              </Button>
            </motion.div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default IntroSection;
